import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { updateRoom } from '../slices/roomSlice'
import Confetti from 'react-confetti'


export default function MultiPlayerGame() {

    let [showId, setShowId] = useState(false)
    let [open, setOpen] = useState(true)
    let [name, setName] = useState('')
    let { room } = useSelector(state => state.roomSlice)
    let { userId, socket } = useSelector(state => state.userSlice)
    let dispatch = useDispatch()
    let { id } = useParams()

    let updateBoard = (row, col) => {
        let data = {
            row, col, roomId: room.roomId, userId
        }
        socket.emit('updateBoard', data)
    }


    let updateName = () => {
        setOpen(false)
        if (room.creatorId === null) {
            let obj = { roomId: id, creatorId: userId, creatorName: name }
            socket.emit('createRoom', obj)
            socket.on('roomCreated', async (data )=> {
                await dispatch(updateRoom(data))
            })
            setShowId(true)
        }
        else {
            let obj = { roomId: id, otherPlayerId: userId, otherPlayerName: name }
            socket.emit('updateOpponent', obj)
        }
    }

    socket.on('updateRoom', async(data) => {
        await dispatch(updateRoom(data))
    })

    const config = {
        angle: 90,
        spread: 360,
        startVelocity: 40,
        elementCount: 70,
        dragFriction: 0.12,
        duration: 3000,
        stagger: 3,
        width: "10px",
        height: "10px",
        perspective: "500px",
        colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"],
    };


    return (
        <div className="Game">

            <div className="score-card">
                <div className="score">
                    <p className="text">{room.creatorName}</p>
                    <p className="text1 blue">{room.creatorScore}</p>
                </div>
                <div className="score">
                    <p className="text">{room.otherPlayerName}</p>
                    <p className="text1 red">{room.otherPlayerScore}</p>
                </div>
            </div>
            <div className="game-status">
                <div className="header">
                    <p className="text1">{room.gameState}</p>
                    {(userId === room.creatorId && room.creatorTurn && room.active && room.otherPlayerId !== null) && (<p className="turn">Your Turn : X</p>)}
                    {(userId === room.creatorId && !room.creatorTurn && room.active && room.otherPlayerId !== null) && (<p className="turn">{room.otherPlayerName}'s Turn : O</p>)}
                    {(userId === room.otherPlayerId && room.otherPlayerTurn && room.active && room.otherPlayerId !== null) && (<p className="turn">Your Turn : O</p>)}
                    {(userId === room.otherPlayerId && !room.otherPlayerTurn && room.active && room.otherPlayerId !== null) && (<p className="turn">{room.creatorName}'s Turn : X</p>)}
                    {(!room.active) && (<p className="turn">Click restart to start another match!</p>)}
                </div>

                {!room.active && (<button className="restart" onClick={() => socket.emit('restart', room.roomId)}>Restart</button>)}

                <div className="board">
                    {room.board.map((el, row) => { return (el.map((item, col) => <button disabled={(room.otherPlayerId === null) || (!room.active) || (userId === room.creatorId && !room.creatorTurn) || (userId === room.otherPlayerId && !room.otherPlayerTurn)} onClick={() => updateBoard(row, col)} className={item === 'X' ? "board-room blue" : item === 'O' ? "board-room red" : "board-room"}>{item}</button>)) })}
                </div>
            </div>

            {open && <div className="join-room">
                <div className="join-room-div">
                    <div className="input-div">
                        <label htmlFor="name">Enter Your Name : </label>
                        <input type="text" name="name" value={name} onChange={(e) => setName(e.target.value)} />
                    </div>
                    <button className="join-btn" onClick={() => updateName()}>Submit</button>
                </div>
            </div>}

            {showId && <div className="join-room">
                <div className="join-room-div">
                    <div className="input-div">
                        <label htmlFor="name">Share this room id "{id}" with your friend. </label>
                    </div>
                    <button className="join-btn" onClick={() => { navigator.clipboard.writeText(id); setShowId(false) }}>Copy to clipboard</button>
                </div>
            </div>}

            {(!room.active && room.winnerId === userId) && <Confetti config={config} className="confetti" />}
        </div>
    )
}
